import React, { Component } from 'react'
import { Segment, Header, Table, Checkbox } from 'semantic-ui-react'

export default class Settings extends Component {
  constructor(props) {
    super(props)

    this.proModeToggled = this.proModeToggled.bind(this)
    this.notificationSoundsDisabledToggled = this.notificationSoundsDisabledToggled.bind(this)
  }

  render() {
    return (
      <Segment>
        <Header>Settings</Header>
        <Table>
          <Table.Body>
            <Table.Row>
              <Table.Cell>Classic Mode</Table.Cell>
              <Table.Cell>
                <Checkbox toggle checked={this.props.proLayoutEnabled} onChange={this.proModeToggled} />
              </Table.Cell>
              <Table.Cell>Classic mode changes the apperance to be more of a "standard" IRC look. It'll fit more on the screen and remove avatars.</Table.Cell>
            </Table.Row>
            <Table.Row>
              <Table.Cell>Disable Notification Sounds</Table.Cell>
              <Table.Cell>
                <Checkbox toggle checked={this.props.notificationSoundsDisabled} onChange={this.notificationSoundsDisabledToggled} />
              </Table.Cell>
              <Table.Cell>Turn off the notification chirp that plays when you have #TheCabin in the background.</Table.Cell>
            </Table.Row>
          </Table.Body>
        </Table>
      </Segment>
    )
  }

  proModeToggled() {
    const enabled = !this.props.proLayoutEnabled
    if (this.props.proLayoutEnabledChanged) {
      this.props.proLayoutEnabledChanged(enabled)
    }
  }

  notificationSoundsDisabledToggled() {
    const enabled = !this.props.notificationSoundsDisabled
    if (this.props.notificationSoundsDisabledChanged) {
      this.props.notificationSoundsDisabledChanged(enabled)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/settings/Settings.jsx